import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LimitToPipe } from './limit-to/limit-to.pipe';
import { LimitToEllipsisPipe } from './limit-to-ellipsis/limit-to-ellipsis.pipe';
import { UniquePipe } from './unique/unique.pipe';
import { FilterPipe } from './filter/filter.pipe';

import { Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { SecondsPipe } from './seconds/seconds.pipe';
import { Nl2brPipe } from './nl2br/nl2br.pipe';
import { AbbreviatedNumberPipe } from './abbreviated-number/abbreviated-number.pipe';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

  transform(
    code: string,
    format: 'wide' | 'narrow' = 'narrow',
    locale?: string
  ): any {
    return getCurrencySymbol(code, format, locale);
  }
}

const Pipes = [
  LimitToPipe,
  LimitToEllipsisPipe,
  UniquePipe,
  FilterPipe,
  CurrencySymbolPipe,
  SafeHtmlPipe,
  SecondsPipe,
  Nl2brPipe,
  AbbreviatedNumberPipe
]

@NgModule({
  declarations: [
    ...Pipes,
    Nl2brPipe,
    AbbreviatedNumberPipe
  ],
  exports: [
    ...Pipes
  ],
  imports: [
    CommonModule
  ]
})
export class PipeModule { }
